import { BuddyPageMatching } from '@adornis/bh-matching-matches/components/buddy-page-matching.js';
import { MentoringMentor } from '../../entities/mentoring-user.js';
import { customElement } from 'lit/decorators.js';
import { html } from 'lit';
import { css } from '@adornis/chemistry/directives/css.js';
import './../components/mentoring-user-details.js';
import { logger } from '@adornis/base/logging.js';
import { MatchAPI } from '@adornis/bh-matching-matches/api/matchAPI.js';
import { Match } from '@adornis/bh-matching-matches/entities/match.js';
import type { BuddyUserMentor, BuddyUserMentee } from '@adornis/bh-matching-user/entities/buddy-user.js';
import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar.js';
import { XDialog } from '@adornis/dialog/x-dialog.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { userFieldBlackList } from '@adornis/bh-matching-user/user-field-blacklist.js';

@customElement('mentoring-page-matching')
export class MentoringPageMatching extends BuddyPageMatching {
  override _personTogleComponentName = 'mentoring-user-details';

  override _personToggle(user: MentoringMentor, alwaysOpen?: boolean) {
    return html`
      <mentoring-user-details
        ?always-open=${alwaysOpen}
        flex
        ${css({ minWidth: '0', overflow: 'hidden' })}
        .user=${user}
        .fieldBlackList=${[...userFieldBlackList, 'foreignLanguages', 'nativeLanguage', 'preferedMentorsIDs']}
      ></mentoring-user-details>
    `;
  }

  protected override _buttonBar(mentors: BuddyUserMentor[], mentees: BuddyUserMentee[]) {
    const matches = this._matches.value;
    const notAllMatchesFilled = !matches.length || matches.some(m => !m.mentor || !m.mentee);

    return html`
      <x-flex horizontal space="md" end>
        <x-button
          ?disabled=${notAllMatchesFilled}
          @click=${async () => {
        try {
          if (notAllMatchesFilled) return;

          const confirm = await XDialog.confirm(this._translator.translate('buddy', 'createMatchesConfirm'));
          if (!confirm) return;

          const newMatches = matches.map(m => {
            return new Match({
              mentorID: m.mentor?._id,
              menteeID: m.mentee?._id,
              timeframeID: this._currentlySelectedTimeframe.value?._id,
            });
          });
          await XDialog.waitFor(MatchAPI.create(newMatches)());

          this.requestUpdate();
          this._matches.next([]);
          void XSnackbar.show(this._translator.translate('buddy', 'createMatchesSuccessful'));
          void goTo('/matches');
        } catch (e) {
          logger.error(e, 'Something went wrong creating the matches.');
        }
      }}
        >
          ${this._translator.translate('buddy', 'createMatches')}
        </x-button>
      </x-flex>
    `;
  }
}
